import {
    LOADING_DDI,
    SET_LIST_PAIS,
    SET_DDI_FIXO_BRASIL
} from './types';

const initialState = {
    loadingDdi: false,
    ddiFixoBrasil: true,
    listPais: []
};

export default function ddiReducer(state = initialState, action) {
    switch (action.type) {
        case SET_DDI_FIXO_BRASIL:
            return { ...state, ddiFixoBrasil: action.payload }
        case SET_LIST_PAIS:
            return { ...state, listPais: action.payload }
        case LOADING_DDI:
            return { ...state, loadingDdi: action.payload }
        default:
            return state
    }
}